import React from "react";

export const getColumns = (firstGroupingName, kpiChooser) => {
    const rawColumns = [
        {name: "absolutePnl", className: "t-absolute-pnl"},
        {name: "absoluteReturnPercent", className: "t-absolute-return-percent"},
        {name: "absoluteHitRate", className: "t-absolute-hit-rate"},
        {name: "relativePnl", className: "t-relative-pnl"},
        {name: "relativeReturnPercent", className: "t-relative-return-percent"},
        {name: "relativeHitRate", className: "t-relative-hit-rate"},
        {name: "customScore", className: "t-custom-score"}
    ];
    return rawColumns.filter(column => kpiChooser.canShow(column.name, firstGroupingName));
};